module.exports = __webpack_public_path__ + "e22fd76caf80fd705f5e3b3546aad008.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/simple-graphics.png
// module id = 2308
// module chunks = 1